import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";

export default function Export() {
    const schema = {
        "@context": "https://schema.org",
        "@type": "Service",
        name: "Sustainable Food Packaging Export",
        serviceType: "International export of paper food packaging",
        description: "Export of aqueous-coated paper salad bowls, soup bowls, kraft containers, PET flat lids and custom-printed food packaging from Bangalore, India. FCA/FOB/CIF Incoterms, EU/UK/GCC compliance documentation, container-ready pallet configurations.",
        areaServed: [{ "@type": "Country", name: "United Arab Emirates" }, { "@type": "Country", name: "Saudi Arabia" }, { "@type": "Country", name: "Qatar" }, { "@type": "Country", name: "United Kingdom" }, { "@type": "Country", name: "Germany" }, { "@type": "Country", name: "Netherlands" }, { "@type": "Country", name: "France" }],
        provider: { "@type": "Organization", "@id": "https://thepuropack.com/#organization", name: "The Puro Pack", url: "https://thepuropack.com" },
        audience: { "@type": "BusinessAudience", audienceType: "Distributors, importers, private-label food brands, retail chains" },
    };
    return (
        <div data-testid="export-page">
            <Seo title="Export Program" description="The Puro Pack ships sustainable paper packaging from Bangalore internationally. FCA/FOB/CIF Incoterms, container-ready pallet configs, HS 4823.69/4823.70 documentation." path="/export" schema={schema} />
            <div className="max-w-[1600px] mx-auto px-6 lg:px-10">
                <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Export", to: "/export" }]} />
            </div>

            <section className="max-w-[1600px] mx-auto px-6 lg:px-10 pt-14 pb-20 grid lg:grid-cols-12 gap-10">
                <div className="lg:col-span-8">
                    <div className="font-mono text-xs uppercase tracking-widest text-clay mb-6">[ Export · Global ]</div>
                    <h1 className="font-serif text-6xl lg:text-8xl leading-[0.92] tracking-tight text-forest">
                        From <em className="italic">Bangalore</em> to your loading dock.
                    </h1>
                </div>
                <div className="lg:col-span-4 lg:pt-24">
                    <p className="text-inkgreen/80 leading-relaxed">
                        We are a full-service export supplier. Container-ready pallet configurations, ocean & air freight, and complete documentation for HS 4823.69 / 4823.70 classifications.
                    </p>
                </div>
            </section>

            <section className="border-t border-forest/30">
                <div className="max-w-[1600px] mx-auto px-6 lg:px-10 py-16">
                    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-0 border-t border-l border-forest/40">
                        {[
                            ["Incoterms", "FCA · FOB · CIF · DDP"],
                            ["Lead time", "14–21 days ex-factory"],
                            ["Ports", "Chennai · Nhava Sheva · Cochin"],
                            ["MOQ (export)", "1 x 20' container"],
                        ].map(([k, v]) => (
                            <div key={k} className="border-r border-b border-forest/40 p-8">
                                <div className="font-mono text-xs uppercase tracking-widest text-stone mb-3">{k}</div>
                                <div className="font-serif text-2xl lg:text-3xl text-forest">{v}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="max-w-[1600px] mx-auto px-6 lg:px-10 py-24 grid lg:grid-cols-2 gap-10">
                <div>
                    <div className="font-mono text-xs uppercase tracking-widest text-stone mb-4">[ Regions ]</div>
                    <h2 className="font-serif text-4xl text-forest tracking-tight mb-6">Where we ship.</h2>
                    <ul className="space-y-4 text-inkgreen/80">
                        <li className="border-t border-forest/30 pt-4"><span className="font-mono text-clay">GCC · </span> UAE · Saudi Arabia · Qatar · Bahrain · Oman · Kuwait</li>
                        <li className="border-t border-forest/30 pt-4"><span className="font-mono text-clay">EU · </span> Germany · France · Netherlands · Italy · Spain</li>
                        <li className="border-t border-forest/30 pt-4"><span className="font-mono text-clay">UK · </span> Full DDP program with UK distribution partner</li>
                    </ul>
                </div>
                <div className="image-frame aspect-[4/5]">
                    <img src="https://images.unsplash.com/photo-1518531933037-91b2f5f229cc?w=1200&q=85" alt="Global export program" loading="lazy" />
                </div>
            </section>

            <section className="bg-forest text-bone">
                <div className="max-w-[1600px] mx-auto px-6 lg:px-10 py-24 flex flex-col lg:flex-row justify-between items-start lg:items-end gap-10">
                    <h2 className="font-serif text-5xl lg:text-7xl tracking-tight max-w-3xl">Enquire about <em className="italic">export pricing</em> and Incoterms.</h2>
                    <Link to="/contact" className="btn-pill border-bone text-bone hover:bg-bone hover:text-forest" data-testid="export-cta">Start Enquiry →</Link>
                </div>
            </section>
        </div>
    );
}
